module.exports = __webpack_public_path__ + "img/pic26.3b30ddaf.png";